import HeroTitle from '#app/components/hero-title.tsx'
import { Footer } from '#app/components/footer.tsx'

export default function OurStoryRoute() {
	return (
		<div className="container flex max-w-6xl flex-col justify-center pb-48 pt-12 text-black">
			<div className="rounded-xl bg-white">
				<div className="mx-auto max-w-7xl px-6 lg:px-8 mb-16">
					<HeroTitle
						title="Our Story"
						subject="About Us"
						description="Passionately committed to making the best client-accountant collaboration tools."
					/>
					<div className="mt-10 text-center">
						<img src="/img/building2.png" alt="office" className="rounded-xl" />
					</div>
					<div className="mt-20 sm:flex sm:max-w-5xl sm:justify-between sm:gap-60">
						<div className="whitespace-nowrap">
							<h3 className="text-h3">How it started?</h3>
						</div>
						<div className="mt-10 flex flex-col gap-10 font-mono sm:mt-0">
							<div>
								The refundr team consists of a group of Canadians from the Windsor and Montreal area. We collectively
								possess more than 40 years of expertise in the tax return industry. As a proud family-run business, our
								team boasts diverse expertise ranging from tax consultants, coders, and sales.
							</div>
							<div>
								Our refundr journey began in 2019 with a shared goal of revolutionizing the consultant-client experience
								in tax services. Recognizing the need to streamline and simplify the tax filing process for Canadians
								during the chaos of tax season, we set out to explore more useful digital solutions. To our surprise, we
								found a large gap in available tools, prompting us to embark on building tool that tax accountants will
								love.
							</div>
							<div>We have come along way over the years!</div>
						</div>
					</div>
					{/*<div className="container mx-auto py-20">*/}
					{/*    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/joyce.png" alt="Joyce" className="max-w-full h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/weijia2.png" alt="Weijia" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/victoria.png" alt="Victoria" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/ivo.png" alt="Ivo" className="max-w-full h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/matt.jpg" alt="Matt" className="max-w-48 h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*        <div className="flex justify-center items-center bg-gray-200 rounded p-4">*/}
					{/*            <img src="/img/team/mike.png" alt="Mike" className="max-w-48  h-auto rounded"/>*/}
					{/*        </div>*/}
					{/*    </div>*/}
					{/*</div>*/}

					<div className="mt-36 sm:flex sm:max-w-5xl sm:justify-between sm:gap-60">
						<div className="whitespace-nowrap">
							<h3 className="font-mono text-h3">How is it going?</h3>
						</div>
						<div className="mt-10 flex flex-col gap-10 font-mono sm:mt-0">
							<div>
								After gathering feedback from numerous tax consultants and their clients, we are thrilled to unveil what
								we believe to be an exceptional blend of technology that truly delivers in streamlining the chaos of tax
								season.
							</div>
							<div>
								What excites us the most, amidst the overwhelming positive feedback, is the opportunity to collaborate
								with fellow Canadian tax consultants nationwide. Together, we aim to enhance their tax return and client
								management workflows with a solution that resonates with them.
							</div>
							<div>
								If you're a tax consultant seeking to augment your current business operations with a fresh approach, we
								invite you to explore our{' '}
								<a href="https://dashboard.refundr.ca/signup" target="_blank" className="text-blue-700 underline">
									dashboard
								</a>{' '}
								today or{' '}
								<a
									href="https://calendly.com/refundr-michael/30min"
									target="_blank"
									className="text-blue-700 underline"
								>
									Take a Quick Tour
								</a>{' '}
								and schedule a call to learn more about how we can partner together.
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	)
}
